import { MONDAY_CLIENT_ID } from '@config/constants';
import type { IntegrationInstallInstructionsProps } from '@pages/AdminSettings/components/IntegrationTab/constants';
import { useLayoutEffect } from 'react';

export default function MondayInstallInstructions({
  onClose
}: IntegrationInstallInstructionsProps) {
  useLayoutEffect(() => {
    onClose();
    window.open(
      `https://auth.monday.com/oauth2/authorize?client_id=${MONDAY_CLIENT_ID}&response_type=install`,
      '_blank'
    );
  }, [onClose]);
  return null;
}
